<template>
  <div class="atomic-menu-category-activator">
    <atomic-link v-if="isDrawerCompact" :href="url" @click.stop>
      <svg xmlns="http://www.w3.org/2000/svg" class="icon">
        <use :href="`/sprite-nav-mobile.svg#${icon}`" />
      </svg>
    </atomic-link>

    <atomic-link v-else :href="url">
      <svg  xmlns="http://www.w3.org/2000/svg" class="icon">
        <use :href="`/sprite-nav-mobile.svg#${icon}`" />
      </svg>


      <div class="atomic-menu-category-activator__label">
        {{ label }}
      </div>
    </atomic-link>

    <slot />

    <atomic-icon
      @click.stop="emit('toggle')"
      class="atomic-menu-category-activator__arrow-icon"
      :class="{ 'atomic-menu-category-activator__arrow-icon--active': isOpen }"
      id="arrow_expand-close"
    />
  </div>
</template>

<script setup lang="ts">
  import type { IIconLink } from '~/types';

  defineProps<{
    icon: string;
    label: string;
    url: string;
    items: IIconLink[];
    isOpen: boolean;
    isDrawerCompact: boolean;
  }>();

  const emit = defineEmits(['toggle']);


</script>

<style src="~/assets/styles/components/nav/menu/category-activator.scss" lang="scss" />
